if(!customElements.get('logos-scroller')) {
  customElements.define(
    'logos-scroller',
    class LogosScroller extends HTMLElement {
      sliderEl = null;
      sliderInstance = null;

      constructor() {
        super();
      }

      connectedCallback() {
        this.sliderEl = this.querySelector('[data-slider]');
        this.init();
      }

      init() {
        if(!this.sliderEl) {
          return console.error('An error ocurred initializing logos scrolled. No slider element was found.');
        }

        this.sliderInstance = new Swiper(this.sliderEl, {
          loop: true,
          slidesPerView: 2,
          spaceBetween: 20,
          speed: 10000,
          autoplay: {
            disableOnInteraction: false,
            delay: 0
          },
          breakpoints: {
            768: {
              slidesPerView: 3
            },
            1024: {
              slidesPerView: 5
            },
          }
        });
      }
    }
  );
}
